import React, { useState } from 'react'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import { styles } from './styles'
import { beforeUpload, compressFile, isMobile } from '../../utils'
import Logo from '../../components/Logo'
import TitleBin from '../../components/TitleBin'
import { Col, Form, Input, Modal, Row, Upload } from 'antd'
import axios from 'axios'
import { isEmpty } from 'lodash'
import { ButtonEx } from '../HeroLocations/index.style'
import AddBin, { ButtonUploadDiv } from './AddBin'
import AddLocation from './AddLocation'
import BinSelect from './BinSelect'
import BackIcon from '@material-ui/icons/ArrowBack'
import { useDeepEffect } from '../../utils/hooks'
import AddIcon from '../../assets/icons/Add_image.png'
import { CardMaterialEx } from '../../material.style'
import { CardContentEx, FormItem } from '../../shared.style'
import { isNumeric } from '../../utils/number'
import { compose, graphql, withApollo } from 'react-apollo'
import { GET_MATERIAL_LIST } from '../../graphql/queries'
import MainStep4 from '../../components/MainStep4'

export const SignupBin = ({ history, data }) => {
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [avatarId, setAvatarId] = useState(0)
  const [page, setPage] = useState('1')
  const [formData, setFormData] = useState({})
  const [binSelect, setBinSelect] = useState('1')
  const [circularBinMaterials, setCircularBinMaterials] = useState([])

  useDeepEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          process.env.REACT_APP_API_ENDPOINT + `/product/circularBinMaterial`
        )
        setCircularBinMaterials(res.data)
      } catch (err) {
        console.log(err)
      }
    }

    fetchData()
  }, [])

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  const handleProfileChange = async (info) => {
    const formData = new FormData()
    if (!isEmpty(info.fileList)) {
      formData.append('image', await compressFile(info.file))
      setFileList(info.fileList)
      try {
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/bin/avatar/image`,
          formData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )
        const { data } = res
        setAvatarId(data.id)
      } catch (err) {
        console.log(err)
      }
    } else {
      setFileList(info.fileList)
    }
  }

  const handleChangeBin = (value) => {
    setBinSelect(value)
  }

  const onFinish = async (values) => {
    const data = {
      avatarId: avatarId,
      email: values.email || '',
      name: values.name,
      password: values.password,
      private: binSelect !== '1',
      tel: values.tel
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/hero/existing`,
        {
          email: data.email,
          name: data.name,
          tel: data.tel
        }
      )

      if (!res.data.isExist) {
        await setFormData(data)
        await setPage('2')
      } else {
        Modal.error({
          content: `${res.data.message}`
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  function onBack(e) {
    e.preventDefault()
    switch (page) {
      case '3':
        setPage('2')
        break
      case '2':
        setPage('1')
        break
      default:
        return null
    }
  }

  return (
    <main style={styles.main}>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          {page !== '1' && page !== '4' ? (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              onClick={(e) => onBack(e)}>
              <BackIcon />
            </IconButton>
          ) : (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              onClick={() => history.goBack()}>
              <BackIcon />
            </IconButton>
          )}
          <Logo />
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
      </AppBar>
      {page !== '4' && (
        <Row type="flex" gutter={16}>
          <Col>
            <TitleBin name="ข้อมูลทั่วไป" no={'1'} page={page} />
          </Col>
          <Col>
            <TitleBin name="สถานที่ Circular Bin" no={'2'} page={page} />
          </Col>
          <Col>
            <TitleBin name="วัสดุที่ถังรองรับ" no={'3'} page={page} />
          </Col>
        </Row>
      )}
      {page !== '4' ? (
        <CardMaterialEx elevation={isMobile ? 0 : 1} square>
          <CardContentEx>
            {page === '1' && (
              <Form form={form} onFinish={onFinish} layout="vertical">
                <FormItem
                  name="profile"
                  rules={[
                    {
                      required: true,
                      message: 'เลือกรูปภาพโปรไฟล์'
                    }
                  ]}
                  label="รูปภาพโปรไฟล์ (เช่น รูปบุคคล, โลโก้)"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}>
                  <Upload
                    name="profileImg"
                    listType="picture"
                    fileList={fileList}
                    maxCount={1}
                    beforeUpload={beforeUpload}
                    onChange={handleProfileChange}>
                    {isEmpty(fileList) && (
                      <ButtonUploadDiv>
                        <img src={AddIcon} alt="" width={80} height={80} />
                      </ButtonUploadDiv>
                    )}
                  </Upload>
                </FormItem>
                <Form.Item
                  name="name"
                  label="ชื่อ Circular Bin"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกชื่อ Circular Bin'
                    }
                  ]}>
                  <Input placeholder="เช่น ชื่อบุคคล, องค์กร, แบรนด์" />
                </Form.Item>
                <Form.Item
                  name="tel"
                  label="เบอร์โทรศัพท์ (Telephone)"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกเบอร์โทรศัพท์'
                    },
                    {
                      min: 9,
                      message: 'กรอกอย่างน้อย 9 - 10 ตัวเลข'
                    }
                  ]}>
                  <Input maxLength={10} onKeyPress={isNumeric} />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="อีเมล (Email)"
                  rules={[
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    }
                  ]}>
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="รหัสผ่าน (Password)"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกรหัสผ่าน'
                    },
                    {
                      min: 6,
                      message: 'ต้องกรอกอย่างน้อย 6 ตัวอักษร'
                    },
                    {
                      pattern: /^[a-zA-Z0-9\b!@#$%^&_.]+$/,
                      message: 'กรอกภาษาอังกฤษ ตัวเลข หรือ สัญลักษณ์ เท่านั้น'
                    }
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="confirm"
                  label="ยืนยันรหัสผ่าน (Confirm Password)"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: 'กรอกยืนยันรหัสผ่าน'
                    },
                    {
                      pattern: /^[a-zA-Z0-9\b!@#$%^&_.]+$/
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve()
                        }
                        return Promise.reject(new Error('รหัสผ่านไม่ตรงกัน'))
                      }
                    })
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item label="ประเภทถังขยะ">
                  <Row gutter={[8, 8]}>
                    <Col span={12}>
                      <BinSelect
                        name="สาธารณะ"
                        onChange={handleChangeBin}
                        value={binSelect}
                        valueSelect="1"
                      />
                    </Col>
                    <Col span={12}>
                      <BinSelect
                        name="ส่วนตัว"
                        onChange={handleChangeBin}
                        value={binSelect}
                        valueSelect="2"
                      />
                    </Col>
                  </Row>
                </Form.Item>
                <Row justify="center" style={{ marginTop: 15 }}>
                  <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                    ต่อไป
                  </ButtonEx>
                </Row>
              </Form>
            )}
            {page === '2' && (
              <AddLocation
                setPage={setPage}
                setFormData={setFormData}
                formData={formData}
              />
            )}
            {page === '3' && (
              <AddBin
                categories={data.categories}
                beforeUpload={beforeUpload}
                setPage={setPage}
                history={history}
                formData={formData}
                circularBinMaterials={circularBinMaterials}
              />
            )}
          </CardContentEx>
        </CardMaterialEx>
      ) : (
        <MainStep4 history={history} />
      )}
    </main>
  )
}

export default compose(withApollo, graphql(GET_MATERIAL_LIST))(SignupBin)



// WEBPACK FOOTER //
// ./src/pages/SignupBin/index.js